import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { SpinnerClass } from "core/classes/spinner.class";

let spinnerOptions = function () {
    return {
        classes: {
            disablePopup: "disablePopup",
            redirect: "redirect",
            popupClass: "abacusPopup",
            popupContentClass: ".abacusPopupContent",
            popupCloseClass: "closePopup",
            activatePopup: "show",
            bodyClass: "popupActivated",
            loaderClass: "loading"
        }
    };
};

class ImageFilename extends Class {
    constructor(element) {
        super();
        this.element = $("[data-image-name]");
        this.$filenameVal = $("[data-filename]");
        this.$image = $("[data-user-image] > img");
        this.$newfileName = $("[data-file-label]");
        this.container = $(".avatarField");
        this.removeButton = $(".avartarUploadLabel.remove");
        this.setOptions(spinnerOptions());
        this.setUpEvents();
    }

    setUpEvents() {
        let self = this;
        this.element.on("change", function (evt) {
            self.getFilename();
        });
        this.removeButton.on("click", function (evt) {
            evt.preventDefault();
            self.ajaxImg();
        });
    }

    getFilename() {
        let $file = this.element
            .val()
            .split("\\")
            .pop();
        if ($file.length) {
            this.$filenameVal.text($file);
            this.$image.addClass("transluscent");
            this.$newfileName.removeClass("hidden");
        } else {
            this.$filenameVal.text("");
            this.$image.removeClass("transluscent");
            this.$newfileName.addClass("hidden");
        }
    }

    ajaxImg() {
        let self = this;

        this.removeErrorText();
        $.ajax({
            url: `${this.container.data().uid}/removeavatar`,
            beforeSend: function () {
                self.spinner = new SpinnerClass(self.container, {
                    spinnerOptions: {
                        color: "#fff",
                        length: 4,
                        width: 3,
                        radius: 7
                    }
                });
                self.container.addClass(self.options.classes.loaderClass);
            }
        })
            .fail(function () {
                self.addErrorText();
            })
            .done(function (html, data, jqXHR) {
                if (jqXHR.statusText == "OK" && html != "ERROR") {
                    self.replaceContent(html);
                } else {
                    self.addErrorText();
                }
            })
            .always(function () {
                self.removeLoadingState();
            });
    }

    replaceContent(html) {
        this.container.html(html);
    }

    addErrorText() {
        this.removeLoadingState();
        this.container.append(`<div class="ajaxError"><p class="errorbox">${this.container.data().errorText}</p></div>`);
    }

    removeErrorText() {
        this.container.children(".ajaxError").remove();
    }

    removeLoadingState() {
        this.container.removeClass("loading");
        this.spinner.hide();
    }
}

export { ImageFilename }


// WEBPACK FOOTER //
// ./Javascript/core/classes/account/account.image.class.js